import { useQueryParam, StringParam } from "use-query-params";

export const useOrderingQueryParam = () => {
  const [state, setState] = useQueryParam("ordering", StringParam);
  return [state, (v: string) => setState(v || undefined)] as const;
};
